import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { GetOfertasTrabajoDetalleResponse } from '../../egresado/responses/get-detalles-oferta-egr-response';
import { AdmModalValidarofertaComponent } from '../adm-modal-validaroferta/adm-modal-validaroferta.component';
import { EstatusOfertaEmpresaType, UpdateAdmOfertaValidacionRequest } from '../requests/update-adm-oferta-validacion-request';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-ofertas-detalles',
  templateUrl: './adm-ofertas-detalles.component.html',
  styleUrls: ['./adm-ofertas-detalles.component.css']
})
export class AdmOfertasDetallesComponent implements OnInit{
  public breadcrumb: any;

  options = {
    close: false,
    expand: true,
    minimize: false,
    reload: false
  };

  idOferta : number;
  detallesOferta : GetOfertasTrabajoDetalleResponse;
  accionOferta : EstatusOfertaEmpresaType;
  submitted = false;

  constructor(private adminService : AdminService,
              private _route: ActivatedRoute,
              private router : Router,
              private toast : ToastrService,
              private modalService: NgbModal){   
  }

  async ngOnInit() 
  {
    this._route.queryParams.subscribe((params) => {
      if (params.idOferta) {
        this.idOferta = JSON.parse(params.idOferta);
      }
    });

    if(!(this.idOferta>0))
    {
      this.toast.error('No fue posible cargar los datos de la oferta.','Error');
      this.router.navigate(['onlyadminaccess/ofertas'], {
        queryParams: {},
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }

    if(await !this.getOfferDetails(this.idOferta)) // obtener id dinámico
    {
      this.toast.error('No fue posible cargar los datos de la oferta.','Error');
      this.router.navigate(['onlyadminaccess/ofertas'], {
        queryParams: {},
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    this.breadcrumb = {
      'mainlabel': 'Detalles Oferta'
    };
  }

  async getOfferDetails(idOferta:number) : Promise<Boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.adminService.getDetallesOferta(idOferta));
      if(data)
      {
        this.detallesOferta = data;
        this.toast.success('Ya puedes revisar los detalles.','Datos Obtenidos');
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async aprobarOferta()
  {
    const modalRef = this.modalService.open(AdmModalValidarofertaComponent,{ windowClass: 'animated fadeInUp',keyboard:false,backdrop: false });
    modalRef.componentInstance.title = 'Aprobar Oferta';
    modalRef.componentInstance.message = 'La oferta pasará a estar activa y será publicada, por lo que se podrán realizar acciones sobre esta como recibir postulaciones y los ofertadores tendrán la posibilidad de contactar a los postulantes.';
    modalRef.result.then(async (result) => {
      if (result === 'accept') 
      {// El usuario ha aceptado el modal
        try
        {
          this.accionOferta = EstatusOfertaEmpresaType.Aprobada;
          const dataBinded = this.dataBinding();
          if(!dataBinded)
            return;
          const result = await firstValueFrom(this.adminService.updateEstadoOferta(dataBinded));
          if(!result)
              {
                this.toast.error('No fue posible aplicar la validación. Inténtalo de nuevo.','Error');
                return;
              }
              this.toast.success('La oferta ahora está publicada y activa para los interesados.','Oferta aprobada');
              this.router.navigate(['onlyadminaccess/ofertas-activas']);
        }
        catch (error) {
          // manejar el error
        }
          return false;
      }
    }, (reason) => {
      // El usuario ha cerrado el modal sin hacer clic en ningún botón
    });
  }
  
  

  async descartarOferta()
  {
    const modalRef = this.modalService.open(AdmModalValidarofertaComponent,{ windowClass: 'animated fadeInUp',keyboard:false,backdrop: false });
    modalRef.componentInstance.title = 'Descartar Oferta';
    modalRef.componentInstance.message = 'La oferta no se publicará y no podrán realizarse acciones sobre ella por los usuarios interesados, sin embargo, quien la haya creado será capaz de observarla en su historial.';
    modalRef.result.then(async (result) => {
      if (result === 'accept') 
      {// El usuario ha aceptado el modal
        try
        {
          this.accionOferta = EstatusOfertaEmpresaType.Rechazada;
          const dataBinded = this.dataBinding();
          if(!dataBinded)
            return;
          const result = await firstValueFrom(this.adminService.updateEstadoOferta(dataBinded));
          if(!result)
              {
                this.toast.error('No fue posible aplicar la acción. Inténtalo de nuevo.','Error');
                return;
              }
              this.toast.success('La oferta no se publicará.','Oferta eliminada');
              this.router.navigate(['onlyadminaccess/ofertas']);
        }
        catch (error) {
          // manejar el error
        }
          return false;
      }
    }, (reason) => {
      // El usuario ha cerrado el modal sin hacer clic en ningún botón
    });
  }

  dataBinding()
  {
    let updateAdmOfertaValidacionRequestObject : UpdateAdmOfertaValidacionRequest = {} as UpdateAdmOfertaValidacionRequest;
    updateAdmOfertaValidacionRequestObject.idOferta = this.detallesOferta.idOferta;
    updateAdmOfertaValidacionRequestObject.Estatus = this.accionOferta;
    updateAdmOfertaValidacionRequestObject.idnotificacionDeOferta = this.detallesOferta.idnotificacionDeOferta;
    updateAdmOfertaValidacionRequestObject.puesto = this.detallesOferta.descripcionPuesto;
    return updateAdmOfertaValidacionRequestObject;  
  }

  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  onProjectInfoSubmit() {
    this.submitted = true;
  }
}
